import { SET_SEARCH_TEXT } from './actionConstants';

export const setSearchText = (text: string) => {
  return {
    type: SET_SEARCH_TEXT,
    payload: text,
  };
};
